import styled from 'styled-components'
import { CLIENT_STYLINGS, size } from '../../../utils/constants'

export const RatingWrapper = styled.div`
  display: flex;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 15px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.TEXT_COLOR};
  right: 0px;
  line-height: 24px;
  font-weight: 500;
  padding-top: 5px;
`
